import { propertyIdSchema } from "@estate-platform/domain/ids";
import { delMany, get, keys, set } from "idb-keyval";
import { z } from "zod";

import type { Query } from "./query.ts";
import type { PropertyId, UserId } from "@estate-platform/domain/ids";
import type { QueryClient } from "@tanstack/react-query";

const selectionSchema = z.array(propertyIdSchema).catch([]);

const storagePrefix = "estate-platform:property-context:";

const storageKey = (userId: UserId): string => `${storagePrefix}${userId}`;

type PropertyContextQuery = Query<readonly ["preference", "propertyContext", UserId], readonly PropertyId[]>;

export const propertyContextQuery = (userId: UserId): PropertyContextQuery => ({
  queryKey: ["preference", "propertyContext", userId],
  queryFn: async () => selectionSchema.parse((await get<unknown>(storageKey(userId))) ?? []),
});

export const savePropertyContext = async (
  queryClient: QueryClient,
  userId: UserId,
  ids: readonly PropertyId[],
): Promise<void> => {
  queryClient.setQueryData(propertyContextQuery(userId).queryKey, ids);
  await set(storageKey(userId), [...ids]);
};

export const clearPropertyContexts = async (): Promise<void> => {
  const stored = await keys();
  await delMany(stored.filter((key) => typeof key === "string" && key.startsWith(storagePrefix)));
};
